export default __webpack_public_path__ + "static/media/balance-visa.20a17672.svg";